import { render, staticRenderFns } from "./AutoAllocationStatusModal.vue?vue&type=template&id=4c0ec992"
import script from "./AutoAllocationStatusModal.vue?vue&type=script&lang=js"
export * from "./AutoAllocationStatusModal.vue?vue&type=script&lang=js"
import style0 from "./AutoAllocationStatusModal.vue?vue&type=style&index=0&id=4c0ec992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports